import { render, staticRenderFns } from "./documentListDetail.vue?vue&type=template&id=fd99d4a0&"
import script from "./documentListDetail.vue?vue&type=script&lang=js&"
export * from "./documentListDetail.vue?vue&type=script&lang=js&"
import style0 from "./documentListDetail.vue?vue&type=style&index=0&id=fd99d4a0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports